export default {
    en: {
        back                     : "Back",
        save                     : "Save",
        general_error_title      : "Something went wrong",
        general_error_description: "Something went wrong and we cannot complete your request. Please contact the" +
            " application administrator for solution."
    },
    el: {
        back: "Πίσω",
        save: "Αποθήκευση",
        general_error_title      : "Κάτι πήγε λάθος",
        general_error_description: "Κάτι πήγε λάθος και δεν μπορούμε να ολοκληρώσουμε το αίτημα σας. Παρακαλώ" +
            " επικοινωνήστε με τον διαχειριστή της εφαρμογής για επίλυση του προβλήματος."
    }
};